var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEditorAlignTextJustify = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.66675H20M0 15.3334H20M0 10.0001H20",
    stroke: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEditorAlignTextJustify);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-editor-align-text-justify.06e0dafec4459c6b65547ded340e37c0.svg";